import React from "react";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import { Box, FlexDiv } from "@/components/Atoms/Box";
import SelectInput from "@/components/Atoms/Inputs/Select";
import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";
import { isMobile } from "@/utils";
import MoreOfferBanner from "./MoreOfferComponent";
import OfferCardView from "./OfferCardView";
import { OfferCardsContainer } from "./Style";

function OfferPageUI(Props) {
  const { offerPageData } = Props;
  const { heading, subHeading, offersData, moreOffersLogoUrl } = offerPageData;
  return (
    <FlexDiv
      mt={["23px", "23px", "96px"]}
      ml={["16px", "16px", "140px"]}
      mr={["16px", "16px", "140px"]}
      mb={["0px", "0px", "58px"]}
      flexDirection="column"
    >
      <FlexDiv width="100%" justifyContent="space-between" alignItems="center">
        <Typography
          variant="heading4"
          color={theme.colorsV2?.shyft.purple_text}
          py={["0px", "0px", "12px"]}
        >
          {heading}
        </Typography>
        {false && (
          <FlexDiv style={{ gap: "15px" }}>
            <Box width="243px">
              <SelectInput
                variant="v1"
                isSearchable={false}
                options={[{ value: "Shubham", label: "sjsnnsn" }]}
                placeholder="Category"
                name="offer-category"
                //   value={}
                //   onChange={onChange}
                //   menuIsOpen={menuIsOpen}
                containerPadding={"8px 16px 8px 16px"}
                //   dropDownHeight={dropDownHeight}
                dropdownPos="bottom"
                borderRadius="8px"

                //   onBlur={onBlur}
              />
            </Box>
            <Box width="295px">
              <SelectInput
                variant="v1"
                isSearchable={false}
                options={[{ value: "Shubham", label: "sjsnnsn" }]}
                placeholder="Filter by topic"
                name="offer-category"
                //   value={}
                //   onChange={onChange}
                //   menuIsOpen={menuIsOpen}
                containerPadding={"8px 16px 8px 16px"}
                //   dropDownHeight={dropDownHeight}
                dropdownPos="bottom"
                borderRadius="8px"

                //   onBlur={onBlur}
              />
            </Box>
          </FlexDiv>
        )}
      </FlexDiv>
      <Box mt={["16px", "16px", "40px"]}>
        <Typography
          maxWidth={["100%", "100%", "65%"]}
          variant="paragraph2"
          color={theme.colorsV2.blueGray.shade_800}
        >
          {subHeading}
        </Typography>
      </Box>

      <OfferCardsContainer mt="24px" isMobile={isMobile}>
        {offersData.map((item) => {
          return <OfferCardView cardData={item} />;
        })}
        {offersData.length === 1 && (
          <MoreOfferBanner
            moreOffersLogoUrl={moreOffersLogoUrl}
            isCardVariant={true}
          />
        )}
      </OfferCardsContainer>

      {offersData.length > 1 && (
        <MoreOfferBanner
          moreOffersLogoUrl={moreOffersLogoUrl}
          isCardVariant={false}
        />
      )}
    </FlexDiv>
  );
}

export default OfferPageUI;
